export default function assertKeys(
  object: Record<string, unknown> = {},
  arrKeys: string[] = [],
): void {
  arrKeys.forEach((key) => {
    if (typeof object[key] === 'undefined') throw new Error(`Required key ${key} was undefined!`);
  });
}
